/* import __COLOCATED_TEMPLATE__ from './user-companies.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();